import { AxiosResponse } from 'axios'
import { httpAnalitcs } from '../api'
import { Unidade } from '@/core/models';

const controller = 'unidades'

export async function getUnidadeAll(page: number, size: number, term?: string, sort: any = { archived: "asc", id: "desc" }): Promise<any> {
    const stringSort = Object.keys(sort).map(b => `${b}:${sort[b]}`).join(',')

    const { data } = await httpAnalitcs.get<Unidade[], AxiosResponse>(`${controller}?page=${page}&size=${size}&archived=0${(term ? `&nome=${term}` : "")}&sort=${stringSort}`);
    return data;
}

export async function getUnidade(id: string): Promise<Unidade> {

    const { data } = await httpAnalitcs.get<Unidade, AxiosResponse>(`${controller}/${id}`)
    return data;
}

export async function postUnidade(payload: Unidade): Promise<Unidade> {

    const { data } = await httpAnalitcs.post<Unidade, AxiosResponse>(`${controller}`, payload)
    return data;
}

export async function putUnidade(payload: Unidade): Promise<Unidade> {

    const { data } = await httpAnalitcs.put<Unidade, AxiosResponse>(`${controller}/${payload.id}`, payload);
    return data;
}

export async function deleteUnidade(UnidadeId: string): Promise<boolean> {

    const { status } = await httpAnalitcs.delete(`${controller}/${UnidadeId}`);

    return status === 204;
}

// export async function patchCompanhia(payload: Companhia): Promise<AxiosResponse> {
//     return await httpAnalitcs.patch(`${controller}/${payload.id}`, payload)
// }
export async function getUnidadeColetoresInstalados(): Promise<any[]> {

    const { data } = await httpAnalitcs.get<any[], AxiosResponse>(`/unidades-coletores-instalados`)
    return data;
}

export async function getUnidadesPorUsuario(userId:number): Promise<any[]> {

    const { data } = await httpAnalitcs.get<any[], AxiosResponse>(`/unidades-por-usuario/${userId}`)
    return data;
}

